import {
  type CommonCustomErrorResponse,
  type ProblemDetails,
  type WebV1SurveysTriggersListData,
  Surveys
} from '@credit-web/services/product-journey-girar'
import { type AllServicesQueryParams, type TransformTypesToCamelCase } from '@credit-web/services/types'

// eslint-disable-next-line no-restricted-imports
import { type UseQueryRequestOptions, useQueryRequest } from '~/ui/hooks/utils/service/use-query-request'

export type UseSurveysTriggersListResponse = TransformTypesToCamelCase<WebV1SurveysTriggersListData>

/**
 * No description
 *
 * @tags hook
 * @name useSurveysTriggersList
 * @summary Get surveys triggers
 * @request GET:/api/web/v1/surveys/triggers
 * @secure
 * @response `200` `WebV1SurveysTriggersListData` OK
 * @response `400` `CommonCustomErrorResponse` Bad Request
 * @response `403` `ProblemDetails` Forbidden
 */
export const useSurveysTriggersList = (
  query: AllServicesQueryParams,
  queryOptions?: UseQueryRequestOptions<UseSurveysTriggersListResponse, CommonCustomErrorResponse | ProblemDetails>
) => {
  const { data: response, ...restQuery } = useQueryRequest<
    UseSurveysTriggersListResponse,
    CommonCustomErrorResponse | ProblemDetails
  >(['webV1SurveysTriggersList', query.Document], () => Surveys.webV1SurveysTriggersList({ query }), {
    retry: 3,
    retryDelay: 100,
    enabled: Boolean(query.Document),
    ...queryOptions
  })
  return { data: response?.data, content: response?.data?.content, ...restQuery }
}
